import React, { Fragment } from "react";
import PageContentWrapper from "../../../components/wrappers/PageContentWrapper";
import {
  getBearerToken,
  getMailFromUrl,
  getTokenFromUrl,
  logout,
  useIsMobile,
} from "../../../utils/Functions";
import { CHANGE_EMAIL_WITH_TOKEN } from "../../../enums/ApiPaths";
import { ERROR } from "../../../enums/AlertTypes";
import { useTranslation } from "react-i18next";
import authApi from "../../../utils/api/authApi";
import CenterScreen from "../../../components/wrappers/CenterScreen";
import { Button, Paper, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LOGIN } from "../../../enums/UrlPaths";
import png from "../../../assets/png/blue_check.png";
import usePrimaryColor from "../../../hooks/usePrimaryColor";
import { SnackbarContext } from "../../../contexts/Snackbar";
import AuthFooter from "../login/component/AuthFooter";
export default function NewEmailConfirmationPage() {
  const isMobile = useIsMobile();
  const color = usePrimaryColor();
  const [reqeustSent, setRequestSent] = React.useState(false);
  const [showCheckMark, setShowCheckMart] = React.useState(false);
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const { t } = useTranslation();
  const navigate = useNavigate();
  async function sendConfirmation() {
    const data = {
      email: getMailFromUrl(),
    };
    const token = getTokenFromUrl();
    const header = await getBearerToken();
    try {
      let res = await authApi.post(
        CHANGE_EMAIL_WITH_TOKEN + "?token=" + token,
        data,
        {
          headers: header,
        }
      );
      setShowCheckMart(true);
    } catch (error) {
      handleSnackbar("ErrorWhileVerifyingNewEmail", ERROR);
    } finally {
      setRequestSent(true);
    }
  }

  function goToLogin() {
    logout();
    navigate(LOGIN);
  }

  return (
    <PageContentWrapper turnOffLogo={true}>
      <CenterScreen>
        <Paper sx={{ width: isMobile ? "90%" : "35%", p: 2 }}>
          <Stack
            spacing={2}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            {showCheckMark ? (
              <img
                alt="blue_check_icon"
                src={png}
                className="spin-horizontal"
                id="png_icon"
              />
            ) : null}
            {!reqeustSent ? (
              <Fragment>
                <Button
                  variant="filled"
                  sx={{ color: "white" }}
                  onClick={() => {
                    sendConfirmation();
                  }}
                >
                  {t("ConfirmNewEmail")}
                </Button>
                <Typography>
                  {`${getMailFromUrl() ? t("NewEmail") + ": " : ""} ${
                    getMailFromUrl() ?? ""
                  }`}
                </Typography>
              </Fragment>
            ) : (
              <Fragment>
                <Stack sx={{ mt: 2 }}>
                  <Button
                    sx={{ color: "white" }}
                    onClick={() => goToLogin()}
                    variant="filled"
                  >
                    {t("BackToLogIn")}
                  </Button>
                </Stack>
              </Fragment>
            )}
          </Stack>
        </Paper>
      </CenterScreen>
      <AuthFooter />
    </PageContentWrapper>
  );
}
